import { PageHeader } from 'antd'
import React, { FC } from 'react'

type Props = { title: string }

const ImportPageHeader: FC<Props> = ({ title }) => {
  return <PageHeader ghost={false} title={title} />
}

ImportPageHeader.displayName = 'ImportPageHeader'
export default ImportPageHeader
